module.exports = __webpack_public_path__ + "roboto-bold-webfont.bf7e521d5d9602db5e40.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-bold-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-bold-webfont.ttf
// module chunks = styles